import { z } from "zod";

export const PRODUCT_SCHEMA = z
  .object({
    name: z.string().min(1, "Name is required"),
    nameAr: z.string().min(1, "Arabic name is required"),
    externalId: z.string().min(1, "External ID is required"),
    description: z.string().optional().nullable(),
    descriptionAr: z.string().optional().nullable(),
    deliveryNote: z.string().optional().nullable(),
    deliveryNoteAr: z.string().optional().nullable(),
    originalPrice: z.coerce
      .number({ invalid_type_error: "Original price is required" })
      .positive("Original price is required"),
    marketPrice: z.coerce.number().positive().optional().nullable(),
    price: z.coerce.number().optional(),
    priceOverride: z.boolean(),
    position: z.coerce.number().min(0).optional(),
    images: z.string().min(1, "At least one image URL is required"),
    categoryIds: z
      .array(z.string().min(1))
      .min(1, "Choose at least one category"),
    supplierId: z.string().min(1, "Please choose supplier"),
    subCategoryIds: z
      .array(z.string().min(1))
      .min(1, "Choose at least one sub category"),
    brandId: z.string().min(1, "Please choose brand"),
    countryIds: z
      .array(z.string().min(1))
      .min(1, "Choose at least one country"),
    tags: z.array(z.string()),
  })
  .refine(
    (data) => {
      if (data.priceOverride && (!data.price || data.price < 0)) {
        return false;
      }

      return true;
    },
    {
      message: "Price is required when price override is blacklist",
      path: ["price"],
    },
  );

export type ProductFormData = z.infer<typeof PRODUCT_SCHEMA>;
